import React from "react";
import { Box, Grid } from "@mui/material";
import logo from "../../../assets/logo-black/logo-s.svg";
import Contact from "./contact";
import Copyright from "./copyright";
import Links from "./links";

export const PublicFooter: React.FC = () => {
  return (
    <Box sx={{ p: 5, backgroundColor: "warm.main" }}>
      <Grid justifyContent={"space-between"} container flexDirection={"row"}>
        <Grid item xs={12} sm={4}>
          <Box component="img" alt="Logo" src={logo} />
        </Grid>

        <Grid item xs={12} sm={2.5} alignSelf={"flex-end"} paddingLeft={3}>
          <Contact />
        </Grid>
      </Grid>

      <Grid
        sx={{ mt: 5 }}
        justifyContent="space-between"
        alignItems="flex-end"
        container
      >
        <Grid item xs={12} sm={8}>
          <Copyright />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Links />
        </Grid>
      </Grid>
    </Box>
  );
};
export default PublicFooter;
